const searchInput = document.getElementById('researchSearchInput');
const searchBtn = document.getElementById('researchSearchBtn');
const clearBtn = document.getElementById('researchClearBtn');
const statusDiv = document.getElementById('researchSearchStatus');
const searchContainer = document.getElementById('items-grid-container');
const sectionRoot = document.querySelector('.research-section-root');
const sectionId = sectionRoot ? sectionRoot.dataset.sectionId : '';
const domParser = new DOMParser();
const STORAGE_KEY = 'research-search-q';
const inLoadUrlParams = new URLSearchParams(window.location.search);
const onLoadQuery = inLoadUrlParams.get('q');
const originalHTML = searchContainer.innerHTML;
let lastSyncedQuery = null;
let latestRequestId = 0;

function setSearchInputValue(query) {
  if (!query) return '';

  clearBtn.classList.remove('hidden');

  if (lastSyncedQuery === query && searchInput.value === query) {
    return query;
  }

  // iOS Safari form restoration reads the HTML attribute, not only .value
  searchInput.value = query;
  searchInput.setAttribute('value', query);
  searchInput.defaultValue = query;
  sessionStorage.setItem(STORAGE_KEY, query);
  lastSyncedQuery = query;

  return query;
}

function getStoredQuery() {
  // URLSearchParams already decodes the value and turns '+' into a space
  const q = new URLSearchParams(window.location.search).get('q');
  if (q !== null && q.trim() !== '') return q;

  return sessionStorage.getItem(STORAGE_KEY) || '';
}

if (onLoadQuery !== null && onLoadQuery.trim() !== searchInput.value.trim()) {
  const onLoadPage = inLoadUrlParams.get('page') || null;
  displaySearchResults(onLoadQuery.trim(), onLoadPage).catch(err => {
    console.error('Search error:', err);
  });
}

searchInput.addEventListener('keypress', (e) => {
  if (e.key === 'Enter') performSearch();
});

searchBtn.addEventListener('click', performSearch);

clearBtn.addEventListener('click', () => {
  clearURLParams();
  sessionStorage.removeItem(STORAGE_KEY);
  lastSyncedQuery = null;
  searchInput.value = '';
  searchInput.setAttribute('value', '');
  searchInput.defaultValue = '';
  clearBtn.classList.add('hidden');
  statusDiv.textContent = '';
  statusDiv.className = 'search-status hidden';
  searchContainer.innerHTML = originalHTML;
});

searchContainer.addEventListener('click', (e) => {
  const paginationLink = e.target.closest('.research-page-pagination a');
  if (!paginationLink) return;

  const query = searchInput.value.trim() || getStoredQuery();
  if (!query) return;

  e.preventDefault();
  const assignedPage = new URL(paginationLink.href).searchParams.get('page') || '1';
  displaySearchResults(query, assignedPage).catch(err => {
    console.error('Search error:', err);
  });
});

async function performSearch() {
  clearURLParams();
  const query = searchInput.value.trim();

  if (!query) {
    statusDiv.textContent = statusDiv.dataset.noTermsText;
    statusDiv.className = 'search-status error';
    return;
  }

  statusDiv.textContent = statusDiv.dataset.searchText;
  statusDiv.className = 'search-status loading';
  searchBtn.disabled = true;

  try {
    await displaySearchResults(query);
  } catch (err) {
    console.error('Search error:', err);
    statusDiv.textContent = statusDiv.dataset.error;
    statusDiv.className = 'search-status error';
  } finally {
    searchBtn.disabled = false;
  }
}

function clearURLParams() {
  const url = new URL(window.location);
  url.search = '';
  window.history.replaceState({}, '', url)
}

async function displaySearchResults(customQuery = false, page = null) {
  const query = customQuery || searchInput.value.trim() || getStoredQuery();

  if (!query) return

  const requestId = ++latestRequestId;
  const currentUrl = new URL(window.location);
  currentUrl.searchParams.set('q', query);

  if (page && page !== '1') {
    currentUrl.searchParams.set('page', page);
  } else {
    currentUrl.searchParams.delete('page');
  }

  window.history.replaceState({}, '', currentUrl);
  setSearchInputValue(query);

  let fetchUrl = `/search?sections=${sectionId}&type=page&options[prefix]=none&q=${encodeURIComponent(query)}`;
  if (page && page !== '1') {
    fetchUrl += `&page=${page}`;
  }

  const res = await fetch(fetchUrl, { headers: { 'Accept': 'application/json' } });
  if (!res.ok || requestId !== latestRequestId) return;

  const json = await res.json();
  if (requestId !== latestRequestId) return;
  const doc = domParser.parseFromString(json[sectionId], 'text/html');
  const resultsGrid = doc.querySelector("#items-grid-container")
  if (!resultsGrid) return;

  if (resultsGrid.querySelector('.research-page-card')) {
    statusDiv.classList.add('hidden')
    searchContainer.innerHTML = resultsGrid.innerHTML;
    setSearchInputValue(query);

    if (sectionRoot) {
      sectionRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  } else {
    statusDiv.textContent = statusDiv.dataset.noResults;
    statusDiv.className = 'search-status';
    searchContainer.innerHTML = '';
  }
}
